module.exports = __webpack_public_path__ + "img/samsung-galaxy-a70.329ce941.jpg";